<template>
  <div>
    <v-header v-show="showHeader" v-if="!isUnautorizedPage" />
    <v-aside v-if="!isUnautorizedPage" />
    <profile-drawer />
    <v-main class="main">
      <v-container fluid>
        <router-view v-if="routeIsAllowed" :key="$route.path" />
        <access-denied v-else />
      </v-container>
      <blocked-overlay />
      <update-app-massage />
    </v-main>
  </div>
</template>

<script>
  import vHeader from '@/components/header/Header'
  import vAside from '@/components/aside/Aside'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import { mapState } from 'vuex'
  import _ from 'lodash'
  import AccessDenied from '@/components/app/AccessDenied.vue'
  import UpdateAppMassage from '@/components/UpdateAppMassage.vue'
  import ProfileDrawer from '@/components/profile-drawer/ProfileDrawer.vue'
  import BlockedOverlay from '@/components/billing/BlockedOverlay.vue'

  export default {
    name: 'DefaultView',
    components: {
      ProfileDrawer,
      UpdateAppMassage,
      AccessDenied,
      BlockedOverlay,
      vHeader,
      vAside,
    },
    mixins: [mixinSnackbarMessage],
    computed: {
      ...mapState({
        showHeader: (state) => state.app.showHeader,
      }),
      isUnautorizedPage () {
        return this.$route.name === 'Вход' || this.$route.name === 'Регистрация'
      },

      routeIsAllowed () {
        // биллинг открыт тем, кому его дали смотреть; действия внутри — отдельно
        if (this.$route?.meta?.billing && !this.canViewBilling) {
          return false
        }

        // пополнение — действие над чужими деньгами: супер-админу в чужой сети
        // оно закрыто, хотя userCan для него всегда true
        if (this.$route?.meta?.billingAction && !this.canUseBilling) {
          return false
        }

        // разрешения для мобильной версии
        if (
          this.isMobileScreen &&
          !_.isEmpty(this.$route?.meta?.mobilePermissions) &&
          !this.userCan(this.$route.meta.mobilePermissions)
        ) {
          return false
        }

        if (_.isEmpty(this.$route?.meta?.permissions)) {
          return true
        }
        return this.userCan(this.$route.meta.permissions)
      },
    },
    created () {
      this.$store.commit('app/showFloatingButtons')
    },
    mounted () {
      if (this.$router.currentRoute.path !== '/login') {
        this.getFilials()
      }
    },
    methods: {
      getFilials () {
        const payload = {
          limit: 100000,
          offset: 0,
          page: 1,
          type: 'personal',
        }
        this.$store.dispatch('branches/fetchBranches', payload).then((res) => {
          if (res.status === 200) {
          } else {
            this.showErrorMessage(res.response.data.message)
          }
        })
      },
    },
  }
</script>

<style lang="less" scoped>
::v-deep {
  .v-main {
    transition: none !important;
    padding-top: 0 !important;
    // якорь для оверлея блокировки: он накрывает контент, но не шапку и меню
    position: relative;
  }

  .media-lg({
      .v-main {
        padding-top: 20px !important;
        .container {
          padding: 0 5px;
        }
      }
    });
}
</style>
